//用户角色管理
import  request  from "@/utils/request";

//获取菜单权限表
export function getMenuList (){
    return request({
       url:'/api/menu',
       method:'get',
   })
}